interface ChannelMember {
  userId?: string;
}

interface Channel {
  url: string;
  members: ChannelMember[];
}

/* eslint-disable no-unused-vars -- parameter names in callback types are for documentation only */
interface SelectQueryParamChannelArgs {
  uuidParam?: string;
  allChannels: Channel[];
  updateCurrentChannelUrl: (url: string) => void;
  updateCurrentChannelMembers: (members: ChannelMember[]) => void;
  changeToChannelPanel: () => void;
  updateChannelNotFound: () => void;
  sendSegmentEvent: (eventName: string, payload: Record<string, string>) => void;
}
/* eslint-enable no-unused-vars */

/**
 * Finds a channel by searching for a member with the given user ID.
 */
const findChannelByMemberUuid = (uuidParam: string, allChannels: Channel[]): Channel | null => {
  return allChannels.find((channel) => channel.members.some((member) => member.userId === uuidParam)) ?? null;
};

const selectQueryParamChannel = ({
  uuidParam,
  allChannels,
  updateCurrentChannelUrl,
  updateCurrentChannelMembers,
  changeToChannelPanel,
  updateChannelNotFound,
  sendSegmentEvent,
}: SelectQueryParamChannelArgs): void => {
  if (!uuidParam) return;

  const foundChannel = findChannelByMemberUuid(uuidParam, allChannels);

  if (foundChannel) {
    updateCurrentChannelUrl(foundChannel.url);
    updateCurrentChannelMembers(foundChannel.members);
    changeToChannelPanel();

    const selectedChannelPreview = document.getElementById(foundChannel.url);
    selectedChannelPreview?.scrollIntoView();
  } else if (allChannels.length) {
    updateChannelNotFound();
    changeToChannelPanel();
    sendSegmentEvent('Invalid Messaging Link', { uuid_param: uuidParam });
  }
};

export default selectQueryParamChannel;
